package com.partejar.app.feature.agenda.presentation

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.partejar.app.feature.agenda.data.AgendaDataSource
import com.partejar.app.feature.agenda.data.AgendaEvent
import com.partejar.app.feature.agenda.data.AgendaPeriod
import com.partejar.app.feature.agenda.data.AgendaPeriodProvider
import com.partejar.app.feature.agenda.data.SystemAgendaPeriodProvider
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

sealed interface AgendaUiState {
    data object Loading : AgendaUiState
    data class Content(val period: AgendaPeriod, val events: List<AgendaEvent>) : AgendaUiState
    data class Empty(val period: AgendaPeriod) : AgendaUiState
    data class Error(val message: String) : AgendaUiState
}

class AgendaViewModel private constructor(
    private val source: AgendaDataSource,
    private val periodProvider: AgendaPeriodProvider,
    private val scopeOverride: CoroutineScope?,
    @Suppress("UNUSED_PARAMETER") testableConstructor: Unit
) : ViewModel() {
    constructor(source: AgendaDataSource) : this(source, SystemAgendaPeriodProvider(), null, Unit)

    internal constructor(
        source: AgendaDataSource,
        periodProvider: AgendaPeriodProvider,
        scope: CoroutineScope
    ) : this(source, periodProvider, scope, Unit)

    private val scope get() = scopeOverride ?: viewModelScope
    private val _state = MutableStateFlow<AgendaUiState>(AgendaUiState.Loading)
    val state = _state.asStateFlow()

    init {
        reload()
    }

    fun reload() {
        val period = periodProvider.current()
        _state.value = AgendaUiState.Loading
        scope.launch {
            try {
                val events = source.list(period)
                _state.value = if (events.isEmpty()) AgendaUiState.Empty(period) else AgendaUiState.Content(period, events)
            } catch (error: CancellationException) {
                throw error
            } catch (_: Throwable) {
                _state.value = AgendaUiState.Error("Não foi possível carregar a agenda.")
            }
        }
    }
}
